module.exports = __webpack_public_path__ + "img/ascendex.02f4205a.png";